import { createLogger } from '../../../app/logger'
import { getOnlineSelector } from '../networkSlice'
import {
  Typography,
  Box
} from '@mui/material'
import useAppSelector from '../../../hooks/useAppSelector'
import { makeStyles } from 'tss-react/mui'
import clsx from 'clsx'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Testable } from '@eventops/chronotrack-ctlive-mui'
import { useUnsyncedUpdates } from '../../data/hooks/useUnsyncedUpdates'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'CheckinNetworkDetector'
})

const useStyles = makeStyles()((theme) => ({
  snackbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 2,
    background: '#00b0ff',
    padding: 10,
  },
  snackbarIcon: {
    color: theme.palette.primary.contrastText
  },
  bold: {
    fontWeight: 700,
  },
  snackbarText: {
    color: theme.palette.primary.contrastText,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: '24px',
    letterSpacing: 0.25
  }
}))

export type CheckinNetworkDetectorProps = {} & Testable

const CheckinNetworkDetector = (props: CheckinNetworkDetectorProps) => {
  const { classes } = useStyles()
  const unsyncedUpdates = useUnsyncedUpdates()
  const numRequests = unsyncedUpdates.length
  const online = useAppSelector(getOnlineSelector)

  return (
    <Box data-cy={props['data-cy']}>
      {!online &&
        <Box className={classes.snackbar}>
          <InfoOutlinedIcon className={classes.snackbarIcon} />
          <Box>
            <Typography
              className={clsx(classes.snackbarText, classes.bold)}>
              You’re offline, ({numRequests}) changes are not synced.
            </Typography>
          </Box>
          <InfoOutlinedIcon className={classes.snackbarIcon} />
        </Box>
      }
    </Box>
  )
}

export default CheckinNetworkDetector
